export default "__VITE_ASSET__50215f9f__"